export default function SeqBoxSuccess() {
  return (
    <>
      <div className="seq-box success">
        <span className="seq-box-title">What's Coming Next</span>
        <p>
          The next sections walk you through <strong>Latches</strong> →{" "}
          <strong>Flip-Flops</strong>→ <strong>Types</strong> →{" "}
          <strong>Analysis</strong> → <strong>Design Procedures</strong>. Each
          builds on the last.
        </p>
      </div>
    </>
  );
}
